import { useState, useCallback } from 'react';

const STORAGE_KEY = 'topzite-beginner-mode';

export function useBeginnerMode() {
  const [beginnerMode, setBeginnerMode] = useState<boolean>(() => {
    return localStorage.getItem(STORAGE_KEY) !== 'false';
  });

  const toggle = useCallback(() => {
    setBeginnerMode((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  return { beginnerMode, toggle };
}
